import {
    IComponentOptions,
    IController,
    IOnChangesObject,
    IScope,
} from 'angular';
import { CartService } from '../../tn.cart/service.tn.cart';
import { FontStyleService, IFontStyleModel } from '../../tn.common';
import template from './buy-styles-button.html';
import { BuyStylesPopoverController } from './buy-styles-popover';

export class BuyStylesButtonController implements IController {
    // bindings
    // list of style ids to add to list, will be overridden by styles
    styleIds?: number[];
    // list of style models to add to list, takes precedence over styleIds
    styles?: IFontStyleModel[];

    // locals
    popoverController?: BuyStylesPopoverController;
    selectedStyles: IFontStyleModel[] = [];
    cart = this.cartService.getCart();
    cleanupCartWatcher?;

    static $inject = [
        'tn.cart.service',
        'FontStyleService',
        '$scope',
        '$element',
    ];
    constructor(
        protected cartService: CartService,
        protected styleService: FontStyleService,
        protected $scope: IScope,
        protected $element: JQLite
    ) {}

    $onInit(): void {
        this.cleanupCartWatcher = this.$scope.$watch('popover.cart', () =>
            this._updateInCart()
        );
        this.$element.addClass('button_cart');
        this.$element.addClass('button');
    }

    $onChanges(onChangesObj: IOnChangesObject): void {
        // console.log('BuyStylesButtonController.$onChanges', onChangesObj);
        const styles = onChangesObj.styles;
        if (styles && styles.currentValue !== styles.previousValue) {
            // update when styles change
            this._updateInCart();
        }

        const styleIds = onChangesObj.styleIds;
        if (
            !this.styles &&
            styleIds &&
            styleIds.currentValue !== styleIds.previousValue
        ) {
            // give styles priority
            this._updateInCart();
        }
    }

    $onDestroy(): void {
        this.cleanupCartWatcher();
    }

    _updateInCart(): void {
        const styleIds =
            this.styles?.map((style) => style.id) || this.styleIds || [];
        if (this.cartService.stylesInCart(styleIds)) {
            this.$element.addClass('in_cart');
        } else {
            this.$element.removeClass('in_cart');
        }
    }

    clicked($event: Event): void {
        $event.preventDefault();
        // console.log('BuyStylesButtonController.clicked', this.styleIds, this.styles);
        if (this.popoverController?.isVisible) {
            this.popoverController.hide();
            return;
        }
        if (this.styles) {
            this.selectedStyles = this.styles;
            if (this.popoverController == undefined) {
                throw new Error('No popover controller');
            }
            this.popoverController.show();
        }
        if (this.styleIds) {
            // load styles, by the time someone is clicking this button,
            // they're likely already inflight or loaded.
            this.styleService
                .list({
                    id: this.styleIds,
                    page_size: this.styleIds.length + 1 || 0,
                })
                .then(({ results: styles }) => {
                    this.selectedStyles = styles;
                    if (this.popoverController == undefined) {
                        throw new Error('No popover controller');
                    }
                    this.popoverController.show();
                });
        }
    }
}

export const BuyStylesButtonComponentOptions: IComponentOptions = {
    controller: BuyStylesButtonController,
    template,
    bindings: {
        styleIds: '<',
        styles: '<',
    },
};
